export enum EnumTipoAnaliseId {
    BOT = 1,
    IA = 2,
    AUDITOR = 3
}